import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';
import { IonicSelectableComponent } from 'ionic-selectable';

import { UpdateRegistrationAddress2Page } from '../update-registration-address2/update-registration-address2';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { AddressServerProvider } from '../../providers/address-server/address-server';

import { RegistrationAddress } from '../../models/registrationaddress';

/**
 * Generated class for the UpdateRegistrationAddress1Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-address1',
  templateUrl: 'update-registration-address1.html',
})
export class UpdateRegistrationAddress1Page {

  private user: any;
  public registrationAddress: RegistrationAddress;
  public cepSearched: boolean;
  public states: any[] = [];
  public cities: any[] = [];
  public citiesStatus: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private addressServerProvider: AddressServerProvider
  ) {
    this.registrationAddress = new RegistrationAddress();
    this.cepSearched = false;
    this.citiesStatus = false;
    this.states = [
      { id: 'AC', name: 'Acre' },
      { id: 'AL', name: 'Alagoas' },
      { id: 'AP', name: 'Amap\u00e1' },
      { id: 'AM', name: 'Amazonas' },
      { id: 'BA', name: 'Bahia' },
      { id: 'CE', name: 'Cear\u00e1' },
      { id: 'DF', name: 'Distrito Federal' },
      { id: 'ES', name: 'Esp\u00edrito Santo' },
      { id: 'GO', name: 'Goi\u00e1s' },
      { id: 'MA', name: 'Maranh\u00e3o' },
      { id: 'MT', name: 'Mato Grosso' },
      { id: 'MS', name: 'Mato Grosso do Sul' },
      { id: 'MG', name: 'Minas Gerais' },
      { id: 'PA', name: 'Par\u00e1' },
      { id: 'PB', name: 'Para\u00edba' },
      { id: 'PR', name: 'Paran\u00e1' },
      { id: 'PE', name: 'Pernambuco' },
      { id: 'PI', name: 'Piau\u00ed' },
      { id: 'RN', name: 'Rio Grande do Norte' },
      { id: 'RS', name: 'Rio Grande do Sul' },
      { id: 'RJ', name: 'Rio de Janeiro' },
      { id: 'RO', name: 'Rond\u00f4nia' },
      { id: 'RR', name: 'Roraima' },
      { id: 'SC', name: 'Santa Catarina' },
      { id: 'SP', name: 'S\u00e3o Paulo' },
      { id: 'SE', name: 'Sergipe' },
      { id: 'TO', name: 'Tocantins' }
    ];

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationAddress.address = this.user.address;
      this.registrationAddress.addressNumber = this.user.addressNumber;
      this.registrationAddress.addressComplement = this.user.addressComplement;
      this.registrationAddress.addressCountry = this.user.addressCountry;
      this.registrationAddress.addressCity = this.user.addressCity;
      this.registrationAddress.addressState = this.user.addressState;
      this.registrationAddress.addressZip = this.user.addressZip;

      this.cepSearched = ((!this.validatorProvider.isEmpty(this.user.addressState)) || (!this.validatorProvider.isEmpty(this.user.addressCity)));
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationAddress1Page');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSearchZipcode() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para pesquisar pelo CEP.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.addressZip)) {
      this.alertProvider.doAlert('Forneça um CEP.', 'Atenção');
    } else if (!this.validatorProvider.isZipcode(this.registrationAddress.addressZip)) {
      this.alertProvider.doAlert('Forneça um CEP válido.', 'Atenção');
    } else {
      this.cepSearched = false;

      let loader = this.loadingCtrl.create({
        content: 'Pesquisando o CEP...',
        //duration: 3000
      });
      loader.present();

      let addressZip = this.registrationAddress.addressZip.replace(/[^0-9]/g, '');

      let that = this;
      this.addressServerProvider.searchByZip(addressZip).subscribe((data: any) => {
        console.log(data.response);
        loader.dismiss();

        let response = data.response;

        if (response) {
          that.cepSearched = true;
          that.registrationAddress.address = response.address;
          that.registrationAddress.addressNumber = null;
          that.registrationAddress.addressComplement = response.complement;
          that.registrationAddress.addressCountry = response.country;
          that.registrationAddress.addressCity = response.city;
          that.registrationAddress.addressState = response.state;
        } else {
          that.alertProvider.doConfirm('O endereço não foi encontrado com o CEP ' + this.registrationAddress.addressZip + '. Deseja tentar novamente?', () => {
            // Do nothing.
          }, () => {
            that.cepSearched = true;
          });
        }

      }, (error: any) => {
        console.log(error);
        that.cepSearched = true;
        loader.dismiss();
        that.alertProvider.doAlert('Não foi possível pesquisar o CEP.', 'Atenção');
      });
    }
  }

  onStateChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    // console.log('state:', event.value);
    this.cities = [];

    if (event.value) {
      let loader = this.loadingCtrl.create({
        content: 'Buscando as cidades do ' + event.value.name + '...',
        //duration: 3000
      });
      loader.present();

      let that = this;

      this.addressServerProvider.fetchCities(event.value.id).subscribe((data: any) => {
        (data).forEach((item: any) => {
          that.cities.push({
            id: item.id,
            name: item.nome
          });
        });

        // console.log(data);
        // console.log(that.cities);
        this.citiesStatus = true;


        loader.dismiss();
      }, (error: any) => {
        loader.dismiss();
      });
    }
  }

  onCityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    // console.log('city:', event.value);
  }

  doContinue() {
    if (this.validatorProvider.isEmpty(this.registrationAddress.addressZip)) {
      this.alertProvider.doAlert('Forneça o CEP.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.addressState)) {
      this.alertProvider.doAlert('Forneça o estado.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationAddress.addressCity)) {
      this.alertProvider.doAlert('Forneça a cidade.', 'Atenção');
    } else {
      this.navCtrl.push(UpdateRegistrationAddress2Page, {
        user: this.user,
        registrationAddress: this.registrationAddress
      }, {
        animation: 'ios-transition'
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-address1/update-registration-address1.ts